import React from 'react';
import { CreditCardIcon, FileTextIcon, GlobeIcon } from 'lucide-react';
type TrustRowProps = {
  tone?: 'light' | 'dark';
};
const items = [{
  label: 'Digital PDF Collection',
  Icon: FileTextIcon
}, {
  label: 'One-Time Payment',
  Icon: CreditCardIcon
}, {
  label: 'Worldwide Access',
  Icon: GlobeIcon
}];
export function TrustRow({
  tone = 'light'
}: TrustRowProps) {
  const isDark = tone === 'dark';
  return <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-387" data-mp="1p0v6rvi2dtj8">
      {items.map(({
      label,
      Icon
    }) => <li key={label} className={`flex items-center gap-1.5 whitespace-nowrap text-[13px] font-semibold ${isDark ? 'text-white/85' : 'text-ink/70'}`} data-id="element-388" data-mp="1k2jule4ar6xu">
          <Icon className={`h-4 w-4 ${isDark ? 'text-gold' : 'text-electric'}`} aria-hidden="true" data-id="element-389" data-mp="1u0zmvkf28m8x" />
          {label}
        </li>)}
    </ul>;
}